<template>
  <div class="standard-header">
    <span :class="{ rotate: !open }" class="chevron">
      <i class="fa-light fa-chevron-down"></i>
    </span>
    <h3>
      <slot name="header"></slot>
    </h3>
  </div>
</template>

<script>
export default {
  props: {
    header: [String],
    open: [Boolean],
  },
  components: {},
};
</script>

<style lang="less">
.standard-header {
  cursor: pointer;
  user-select: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  // justify-content: space-between;
  h3 {
    margin: 0;
  }
  svg {
    font-size: 12px;
  }
  .chevron {
    transition: 0.1s;
  }
  .rotate {
    transform: rotate(-90deg);
  }
}
</style>
